__turbopack_context__.v({
  "headerContainer": "styles-module__hdN3kq__headerContainer",
  "headerContainer--noBorderBottom": "styles-module__hdN3kq__headerContainer--noBorderBottom",
  "headerWrapper": "styles-module__hdN3kq__headerWrapper",
  "hideSkipLink": "styles-module__hdN3kq__hideSkipLink",
  "logo": "styles-module__hdN3kq__logo",
  "skipLinkContainer": "styles-module__hdN3kq__skipLinkContainer",
  "skipToLink": "styles-module__hdN3kq__skipToLink",
});
